import { sortBy } from 'lodash';
import { useCallback } from 'react';
import uuid from 'react-uuid';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface ILineItemSummariesResponse {
  allItemsReceived: 'N' | 'Y';
  allItemsInvoiced: 'N' | 'Y';
  rowId: string;
  itemNum: string;
  description: string;
  uom: string;
  price: number;
  subTotal: number;
  poQty: number;
  receivedQty: number;
  receivedPercent: number;
  invoicedQty: number;
  invoicedPercent: number;
  selected?: boolean;
}

const useLineItemSummariesApi = (poId: number, immediate: boolean = true) => {
  const call = useCallback(
    () =>
      new Promise<ILineItemSummariesResponse[]>((resolve, reject) => {
        if (poId) {
          axiosInstance
            .get<ILineItemSummariesResponse[]>(`PO/${poId}/lineItemSummaries`)
            .then((res) => {
              resolve(
                sortBy(
                  res.data.map((item) => ({
                    ...item,
                    allItemsReceived: item.receivedPercent >= 100 ? 'Y' : 'N',
                    allItemsInvoiced: item.invoicedPercent >= 100 ? 'Y' : 'N',
                    invoicedPercent: item?.invoicedPercent || 0,
                    receivedPercent: item?.receivedPercent || 0,
                    rowId: uuid(),
                    selected: false,
                  })),
                  ['invoicedPercent', 'receivedPercent']
                )
              );
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          reject();
        }
      }),
    [poId]
  );

  const { isLoading, value, setValue, execute } = useAsync<
    ILineItemSummariesResponse[],
    undefined,
    string
  >(call, immediate);

  return {
    lineItemSummariesLoading: isLoading,
    lineItemSummaries: value,
    setLineItemSummaries: setValue,
    getInvoiceLineItems: execute,
  };
};

export default useLineItemSummariesApi;
